import {
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  withStyles
} from '@material-ui/core'
import { Info, CheckCircle, Cancel, Search } from '@material-ui/icons'
import React, {Component} from 'react'
import {connect} from 'react-redux'
import CollectionCrud from '../../common/Components/CollectionCrud'
import {TextInput, DateInput, CheckboxInput} from '@oniti/oniti-inputs'
import { TextField } from '@material-ui/core'
import InformationsGlobalesCss from './css/InformationsGlobalesCss'
import { collectionActions } from '../../../reducers/collectionsReducer'

class InformationsGlobales extends Component {
  state = {
    selectedSejour: '',
    showDecu: true,
    searchTerm: '',
    paginationFilters: {},
  }

  collectionCrudRef = null;

  componentDidMount() {
    const { dispatch, sejoursStore } = this.props;
    if (!sejoursStore.list) {
      collectionActions(dispatch, 'sejours', 'INDEX');
    }
  }

  handleSejourChange = (event) => {
    this.setState({ selectedSejour: event.target.value }, () => {
      this.triggerReload();
    });
  }

  handleShowDecuChange = (event) => {
    this.setState({ showDecu: event.target.checked }, () => {
      this.triggerReload();
    });
  }

  // Recherche "controlled" : on ne fait que porter la valeur. La DataTable
  // détecte le changement de la prop `search`, réinitialise la page et relance
  // le chargement asynchrone (via oniti_filter) — pas besoin de déclencher le
  // reload nous-mêmes.
  handleSearchChange = (value) => {
    this.setState({ searchTerm: value });
  }

  triggerReload() {
    if (this.collectionCrudRef) {
      this.collectionCrudRef.setDatatablePage(1);
    }

    this.loadAsyncData({
      ...this.state.paginationFilters,
      page: 1,
    });
  }

  loadAsyncData(paginationFilters) {
    let { dispatch, informationsGlobalesStore } = this.props;

    if (informationsGlobalesStore.fetching) return;

    const { selectedSejour, showDecu } = this.state;

    if(paginationFilters) {
      // eslint-disable-next-line
      this.state.paginationFilters = paginationFilters;
    }

    var data_params = {};
    data_params.params = {
      ...this.state.paginationFilters,
      sejour_uuid: selectedSejour || null,
      show_decu: showDecu ? 'true' : 'false',
    };

    if (!data_params.params.oniti_pagination) {
      data_params.params.oniti_pagination = 1;
    }
    if (!data_params.params.oniti_perpage) {
      data_params.params.oniti_perpage = 25;
    }

    return collectionActions(
      dispatch,
      "informations-globales",
      "INDEX",
      data_params,
      null,
      true
    );
  }

  getDate(string) {
    if (!string) return '';
    let date = new Date(string);
    let options = {day: 'numeric', month: 'numeric', year: 'numeric'};
    return date.toLocaleDateString('fr-FR', options);
  }

  getDateTime(string) {
    if (!string) return '';
    let date = new Date(string);
    let options = {day: 'numeric', month: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit'};
    return date.toLocaleString('fr-FR', options);
  }

  formatSejour = (obj) => {
    if (!obj.sejour) return '';
    return obj.sejour.libelle;
  }

  formatNumSejour = (obj) => {
    if (!obj.sejour) return '';
    return obj.sejour.num_sejour || '';
  }

  formatHorodatage = (obj) => {
    return this.getDateTime(obj.created_at);
  }

  formatParent = (obj) => {
    const { classes } = this.props;
    const parts = [
      `${obj.parents_nom} ${obj.parents_prenom}`,
      obj.parents_adresse,
      `${obj.parents_code_postal} ${obj.parents_ville}`,
      obj.parents_telephone,
    ].filter(Boolean);

    return (
      <span title={parts.join(' - ')}>
        {obj.parents_nom} {obj.parents_prenom}
        {obj.parents_email && (
          <>
            {' - '}
            <a href={`mailto:${obj.parents_email}`} className={classes.mailtoLink}>
              {obj.parents_email}
            </a>
          </>
        )}
      </span>
    );
  }

  formatEnfant = (obj) => {
    const sexeLabel = obj.enfant_sexe === 'garcon' ? 'G' : 'F';
    const age = obj.age_sejour !== null ? `${obj.age_sejour} ans` : '';
    return `${obj.enfant_nom} ${obj.enfant_prenom} (${sexeLabel}) - ${this.getDate(obj.enfant_date_naissance)} - ${age}`;
  }

  formatAcompte = (obj) => {
    if (!obj.acompte_enfant) return '';
    return `${parseFloat(obj.acompte_enfant).toFixed(2)} €`;
  }

  formatAcompteTotal = (obj) => {
    if (!obj.acompte_total) return '';
    return `${parseFloat(obj.acompte_total).toFixed(2)} €`;
  }

  formatFactureGeneree = (obj) => {
    return obj.facture_generee ? <CheckCircle style={{color: 'green'}}/> : <Cancel style={{color: 'gray'}}/>;
  }

  formatFacture = (obj) => {
    return obj.sejour_regle ? <CheckCircle style={{color: 'green'}}/> : <Cancel style={{color: 'gray'}}/>;
  }

  formatPassNautique = (obj) => {
    return obj.pass_nautique ? <CheckCircle style={{color: 'green'}}/> : <Cancel style={{color: 'gray'}}/>;
  }

  formatAutoriseImage = (obj) => {
    if (obj.autorise_image === null) return '-';
    return obj.autorise_image ? <CheckCircle style={{color: 'green'}}/> : <Cancel style={{color: 'red'}}/>;
  }

  formatSituationSanitaire = (obj) => {
    const { classes } = this.props;
    if (!obj.situation_sanitaire) return '';
    return (
      <span className={classes.sanitaireCell} title={obj.situation_sanitaire}>
        {obj.situation_sanitaire}
      </span>
    );
  }

  formatCopainParent = (obj) => {
    const { classes } = this.props;
    if (obj.nbr_places < 2) return '';
    const parts = [
      `${obj.copain_resp_nom || ''} ${obj.copain_resp_prenom || ''}`.trim(),
      obj.copain_resp_telephone,
    ].filter(Boolean);

    return (
      <span title={parts.join(' - ')}>
        {parts[0]}
        {obj.copain_resp_email && (
          <>
            {' - '}
            <a href={`mailto:${obj.copain_resp_email}`} className={classes.mailtoLink}>
              {obj.copain_resp_email}
            </a>
          </>
        )}
      </span>
    );
  }

  getSejoursOptions() {
    const { sejoursStore } = this.props;
    if (!sejoursStore.list) return [];
    return sejoursStore.list.map(sejour => (
      <MenuItem value={sejour.uuid} key={sejour.uuid}>
        {sejour.libelle} ({this.getDate(sejour.date_debut)})
      </MenuItem>
    ));
  }

  getCreateUpdateModalTitle(inscription) {
    if (!inscription) {
      return <>
        <Info/>
        <span>Chargement...</span>
      </>
    }

    return <>
      <Info/>
      <span>Édition de l'inscription - {inscription.enfant_prenom} {inscription.enfant_nom}</span>
    </>
  }

  getCreateUpdateModalContent(inscription, store, onChangeHandler) {
    const { classes } = this.props;
    const hasCopain = inscription.nbr_places >= 2;

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="subtitle2" color="primary">Informations famille</Typography>
        </Grid>

        <Grid item xs={6}>
          <TextInput
            id="num_dossier_accoord"
            label="N° dossier famille"
            value={inscription.num_dossier_accoord || ''}
            margin="normal"
            collectionStore={store}
            name="num_dossier_accoord"
            onChangeHandler={onChangeHandler}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <TextInput
            id="qf"
            label="Quotient CAF"
            value={inscription.qf || ''}
            margin="normal"
            collectionStore={store}
            name="qf"
            onChangeHandler={onChangeHandler}
            fullWidth
          />
        </Grid>

        <Grid item xs={12}>
          <TextInput
            id="parents_email"
            label="Email parent"
            value={inscription.parents_email || ''}
            margin="normal"
            collectionStore={store}
            name="parents_email"
            onChangeHandler={onChangeHandler}
            fullWidth
          />
        </Grid>

        <Grid item xs={12}>
          <Divider className={classes.sectionDivider}/>
          <Typography variant="subtitle2" color="primary">Informations enfant</Typography>
        </Grid>

        <Grid item xs={6}>
          <DateInput
            id="enfant_date_naissance"
            label="Date de naissance"
            value={inscription.enfant_date_naissance || ''}
            margin="normal"
            collectionStore={store}
            name="enfant_date_naissance"
            onChangeHandler={onChangeHandler}
            fullWidth
          />
        </Grid>

        <Grid item xs={6}>
          <CheckboxInput
            id="pass_nautique"
            label="Pass nautique"
            value={inscription.pass_nautique || false}
            margin="normal"
            collectionStore={store}
            name="pass_nautique"
            onChangeHandler={onChangeHandler}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            id="infos_divers"
            label="Infos/divers"
            value={inscription.infos_divers || ''}
            margin="normal"
            name="infos_divers"
            onChange={(e) => onChangeHandler('infos_divers', e)}
            fullWidth
            multiline
            rows={3}
            variant="outlined"
          />
        </Grid>

        {hasCopain && (
          <>
            <Grid item xs={12}>
              <Divider className={classes.sectionDivider}/>
              <Typography variant="subtitle2" color="primary">Informations copain</Typography>
            </Grid>

            <Grid item xs={6}>
              <DateInput
                id="copain_date_naissance"
                label="Date de naissance du copain"
                value={inscription.copain_date_naissance || ''}
                margin="normal"
                collectionStore={store}
                name="copain_date_naissance"
                onChangeHandler={onChangeHandler}
                fullWidth
              />
            </Grid>

            <Grid item xs={6}>
              <TextInput
                id="copain_dossier_accoord"
                label="N° dossier famille copain"
                value={inscription.copain_dossier_accoord || ''}
                margin="normal"
                collectionStore={store}
                name="copain_dossier_accoord"
                onChangeHandler={onChangeHandler}
                fullWidth
              />
            </Grid>

            <Grid item xs={12}>
              <TextInput
                id="copain_resp_email"
                label="Email parent du copain"
                value={inscription.copain_resp_email || ''}
                margin="normal"
                collectionStore={store}
                name="copain_resp_email"
                onChangeHandler={onChangeHandler}
                fullWidth
              />
            </Grid>
          </>
        )}
      </Grid>
    );
  }

  getCellsConfig() {
    const { classes } = this.props;

    return [
      {
        datakey: 'sejour',
        title: 'Séjour/stage',
        sortable: false,
        searchable: false,
        format: this.formatSejour,
      },
      {
        datakey: 'num_sejour',
        title: 'N° séjour',
        sortable: false,
        searchable: false,
        format: this.formatNumSejour,
      },
      {
        datakey: 'created_at',
        title: 'Horodatage',
        sortable: true,
        searchable: false,
        format: this.formatHorodatage,
      },
      {
        datakey: 'nbr_places',
        title: 'Places',
        sortable: true,
        searchable: false,
      },
      {
        datakey: 'num_dossier_accoord',
        title: 'N° dossier',
        sortable: true,
        searchable: true,
      },
      {
        datakey: 'num_alloc_caf',
        title: 'N° CAF',
        sortable: true,
        searchable: true,
      },
      {
        datakey: 'qf',
        title: 'QF',
        sortable: true,
        searchable: true,
      },
      {
        datakey: 'payzen_id',
        title: 'Payzen ID',
        sortable: false,
        searchable: true,
      },
      {
        datakey: 'acompte_enfant',
        title: 'Acompte',
        sortable: true,
        searchable: false,
        format: this.formatAcompte,
        className: classes.currency,
      },
      {
        datakey: 'facture_generee',
        title: 'Facturé',
        sortable: false,
        searchable: false,
        format: this.formatFactureGeneree,
        className: classes.checkboxCell,
      },
      {
        datakey: 'sejour_regle',
        title: 'Réglé',
        sortable: false,
        searchable: false,
        format: this.formatFacture,
        className: classes.checkboxCell,
      },
      {
        datakey: 'parents_nom',
        title: 'Parent',
        sortable: true,
        searchable: true,
        format: this.formatParent,
      },
      {
        datakey: 'enfant_nom',
        title: 'Enfant',
        sortable: true,
        searchable: true,
        format: this.formatEnfant,
      },
      {
        datakey: 'navette_arret_name',
        title: 'Navette',
        sortable: false,
        searchable: false,
      },
      {
        datakey: 'infos_divers',
        title: 'Infos/divers',
        sortable: false,
        searchable: true,
      },
      {
        datakey: 'pass_nautique',
        title: 'Pass naut.',
        sortable: false,
        searchable: false,
        format: this.formatPassNautique,
        className: classes.checkboxCell,
      },
      {
        datakey: 'autorise_image',
        title: 'Photo',
        sortable: false,
        searchable: false,
        format: this.formatAutoriseImage,
        className: classes.checkboxCell,
      },
      {
        datakey: 'situation_sanitaire',
        title: 'Situation sanitaire',
        sortable: false,
        searchable: false,
        format: this.formatSituationSanitaire,
      },
      {
        datakey: 'copain_nom',
        title: 'Copain nom',
        sortable: true,
        searchable: true,
      },
      {
        datakey: 'copain_prenom',
        title: 'Copain prénom',
        sortable: true,
        searchable: true,
      },
      {
        datakey: 'copain_sexe',
        title: 'Copain sexe',
        sortable: false,
        searchable: false,
        format: (obj) => {
          if (!obj.copain_sexe) return '';
          return obj.copain_sexe === 'garcon' ? 'G' : 'F';
        },
      },
      {
        datakey: 'copain_date_naissance',
        title: 'Copain naissance',
        sortable: true,
        searchable: false,
        format: (obj) => this.getDate(obj.copain_date_naissance),
      },
      {
        datakey: 'copain_resp',
        title: 'Parent copain',
        sortable: false,
        searchable: true,
        format: this.formatCopainParent,
      },
      {
        datakey: 'copain_dossier_accoord',
        title: 'N° dossier copain',
        sortable: true,
        searchable: true,
      },
    ];
  }

  render() {
    const { classes } = this.props;
    const { selectedSejour, showDecu } = this.state;

    return (
      <Grid container spacing={2} className={classes.container}>
        <Typography
          variant="button"
          gutterBottom
          className={classes.sectionTitle}
        >
          Informations globales
        </Typography>

        <Grid container spacing={2} className={classes.filtersContainer}>
          <Grid item md={4}>
            <FormControl fullWidth>
              <InputLabel>Filtrer par séjour</InputLabel>
              <Select
                value={selectedSejour}
                onChange={this.handleSejourChange}
              >
                <MenuItem value="">Tous les séjours</MenuItem>
                {this.getSejoursOptions()}
              </Select>
            </FormControl>
          </Grid>
          <Grid item md={4}>
            <TextField
              fullWidth
              label="Rechercher"
              type="search"
              value={this.state.searchTerm}
              onChange={(e) => this.handleSearchChange(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item md={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showDecu}
                  onChange={this.handleShowDecuChange}
                  color="primary"
                />
              }
              label="Afficher les inscriptions annulées"
            />
          </Grid>
        </Grid>

        <CollectionCrud
          innerRef={(ref) => this.collectionCrudRef = ref}
          collectionName={'informations-globales'}
          loadDatas={false}
          asynchrone={true}
          asynchroneCallbackLoadData={this.loadAsyncData.bind(this)}
          showBtnEdit={true}
          showBtnAdd={false}
          showBtnDelete={false}
          disabledEnterModal={true}
          createUpdateModalTitle={this.getCreateUpdateModalTitle}
          createUpdateModalContent={this.getCreateUpdateModalContent.bind(this)}
          datatableConfig={{
            showPagination: true,
            showSearch: false,
            search: this.state.searchTerm,
            onSearchChange: this.handleSearchChange,
            rowsPerPageOptions: [20, 50, 100],
            defaultSort: "created_at",
            sortType: "desc",
            rowClassName: (row) => {
              if (row.decu) {
                return classes.rowDecu;
              }
              return '';
            }
          }}
          cellsConfig={this.getCellsConfig()}
        />
      </Grid>
    );
  }
}

InformationsGlobales = withStyles(InformationsGlobalesCss)(InformationsGlobales);

InformationsGlobales = connect((store) => {
  return {
    informationsGlobalesStore: store.collections['informations-globales'],
    sejoursStore: store.collections.sejours,
  }
})(InformationsGlobales);

export default InformationsGlobales
